/*
 * Public API Surface of ngx-lib/color
 */
export * from './color.module';
export * from './color.model';
export * from './color-utils';
export * from './color.component';
